import React from "react";
import { useMyAccount } from "../../context";
import { UserLoggedIn, UserLoggedOut } from "../common/Icons";
import * as styles from "./MyAccountIcon.module.scss";

export const MyAccountIcon: React.FC = () => {
	const { isAuthenticated } = useMyAccount();
	return (
		<a
			href={
				isAuthenticated
					? process.env.GATSBY_MY_ACCOUNT_URL
					: process.env.GATSBY_PROFILE_SIGN_IN_URL
			}
			className={styles.styledlink}
			aria-label={isAuthenticated ? "My account" : "Login"}
		>
			{isAuthenticated ? (
				<UserLoggedIn width="32" height="32" />
			) : (
				<UserLoggedOut width="32" height="32" />
			)}
		</a>
	);
};

export default MyAccountIcon;
